<template>
    <div aria-hidden="true" aria-labelledby="informLabel" class="modal fade" id="div-otp-input" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content rounded-lg">
                <div class="modal-header border-bottom-0 position-relative">
                    <h4 class="modal-title text-left w-100 pr-4">
                        <img class="mb-2px" height="20px" src="@/assets/img/send-otp-successfully.png" width="20px"/>
                        ワンタイムパスワードを送信しました
                    </h4>
                    <button @click="closeModal()" aria-label="Close" class="close modal-close-btn" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-0">
                    <div class="text-left fs-14px mb-4">
                        <span>{{this.params.otpMail}}に届いた認証コードを入力してください。</span>
                    </div>

                    <div class="text-center">
                        <div class="d-inline-block mw-100">
                            <div class="otp-box mb-2" id="otpBox" :class="{'otp-many': params.otpDigits > 6}">
                                <input :id="index === 0 ? 'input-first-otp-number' : null"
                                       :key="index"
                                       autocomplete="one-time-code"
                                       inputmode="numeric"
                                       pattern="\d*"
                                       spellcheck="false"
                                       ref="otpInputs"
                                       v-for="(digit, index) in params.otpDigits"
                                />
                            </div>
                            <div class="error-msg d-none" id="div-verify-otp-failed">
                                {{$t('MSG_TRS_NAF_0217')}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-top-0 pt-0">
                    <div class="row w-100">
                        <div class="col-md-6">
                            <div class="w-100 fs-14px text-right mb-2">&nbsp;</div>
                            <button @click.prevent="clickBtnVerifyOtp()" class="btn btn-sm btn-secondary w-100" disabled id="btn-verify-otp">
                                認証を行う
                            </button>
                            <div class="w-100 fs-14px text-right mt-2">&nbsp;</div>
                        </div>
                        <div class="col-md-6">
                            <div class="w-100 fs-14px text-right mb-2">
                                <span id="count" style="color: #e53935">{{this.otpCountDownRealTime}}</span>
                                <span>秒後に再送できます</span>
                            </div>
                            <button @click.prevent="clickBtnReSendOtp()" class="btn btn-sm btn-secondary w-100" id="btn-resend-otp">
                                認証コードを再送する
                            </button>
                            <div class="w-100 fs-14px text-right mt-2">
                                <span>コードが届かない場合は<a :href=supportLink target="_blank">こちら</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";
    import IConstants from '@/common/constants/IConstants';
    import ServiceUtils from '@/common/utils/ServiceUtils';
    import Config from "@/services/Config";

    export default {
        name: "OtpInput",
        data() {
            return {
                params: {
                    otpDigits: null,
                    otpCountDown: null,
                    otpDuration: null,
                    otpMail: null,
                    screenName: null,
                    mailTypeSelected: null
                },
                supportLink: Config.getRegisterPasskeySupportLink(),
                otpCountDownRealTime: '',
                otpTimer: null
            }
        },
        mounted() {
            this.onOpenEvent()
        },
        methods: {
            onOpenEvent() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_OTP_INPUT, (params) => {
                    $('#div-otp-input')
                        .off('shown.bs.modal')
                        .on('shown.bs.modal', () => {
                            this.initHTMLDefault();
                            this.initOtpInputUI();
                            this.focusFirstOtp();
                            this.startOtpCountdown();
                        })
                        .modal({backdrop: 'static', keyboard: false});
                    this.params = params;
                    $("#div-otp-input").modal("show");
                });
            },
            initHTMLDefault() {
                const currentModal = this.getCurrentModal();
                const inputs = currentModal?.querySelectorAll('.otp-box input');
                inputs?.forEach(input => {
                    input.value = ''
                });

                this.clearOtpErrorState()
                this.disableButton(currentModal?.querySelector('#btn-verify-otp'));
                this.disableButton(currentModal?.querySelector('#btn-resend-otp'))
            },
            async clickBtnVerifyOtp() {
                const currentModal = this.getCurrentModal();
                const inputs = currentModal?.querySelectorAll('.otp-box input');

                const filled = [...inputs].every(i => i.value);
                if (!filled) {
                    this.warningOtpInput();
                    return;
                }

                const otpCode = [...inputs]
                    .map(input => input.value)
                    .join('');
                let requestPayload = {
                    otpCode: otpCode,
                    screenName: this.params.screenName
                };
                await this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .verifyAuthenticateOtp(requestPayload, {headers: {'Content-Type': 'application/json'}})
                    .then(async (authInfo) => {
                        if (authInfo.errorMessage) {
                            this.warningOtpInput();
                            this.showOrClearOtpVerifyFailed(true);

                            inputs.forEach(i => i.value = '');
                            this.disableButton(currentModal?.querySelector('#btn-verify-otp'));
                            return this.focusFirstOtp()
                        }
                        await this.closeModal();
                        this.$modal.showOtpInputResult({result: true})
                    })
            },
            async clickBtnReSendOtp() {
                if (this.otpCountDownRealTime > 0) return;

                await this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .sendAuthenticateOtp(this.params.screenName, this.params.mailTypeSelected)
                    .then(async () => {
                        // ignore send-OTP errors and always display the OTP input screen. Users can resend the OTP afterward
                        this.initHTMLDefault();
                        this.startOtpCountdown();
                        this.focusFirstOtp()
                    })
            },
            showOrClearOtpVerifyFailed(show) {
                const currentModal = this.getCurrentModal();
                if (show) currentModal?.querySelector('#div-verify-otp-failed').classList.remove('d-none');
                else currentModal?.querySelector('#div-verify-otp-failed').classList.add('d-none')
            },
            warningOtpInput() {
                const otpBox = this.getCurrentModal()?.querySelector('#otpBox');
                otpBox.classList.add('error-border');
                otpBox.classList.remove('shake');
                void otpBox.offsetWidth;
                otpBox.classList.add('shake');
            },
            async closeModal() {
                await ServiceUtils.waitModalFullyHidden($("#div-otp-input"));
                this.initHTMLDefault();
                this.resetOtpCountdown('');
            },
            initOtpInputUI() {
                const inputs = this.getCurrentModal()?.querySelectorAll('.otp-box input');
                if (!inputs || !inputs.length) return;

                inputs.forEach((input, idx) => {
                    input.oninput = () => {
                        const value = input.value;
                        if (value.length > 1) {
                            this.distributeValues(value, idx, inputs);
                            return;
                        }
                        if (value) {
                            input.value = value.replace(/\D/g, '');
                            if (input.value && idx < inputs.length - 1) {
                                inputs[idx + 1].focus();
                            }
                        }

                        this.updateOtpValue();
                        this.clearOtpErrorState();
                    };

                    input.onkeydown = (e) => {
                        if (e.key === 'Backspace' && !input.value && idx > 0) {
                            inputs[idx - 1].focus();
                        }
                    };

                    input.onpaste = (e) => {
                        e.preventDefault();
                        const clipboardData = e.clipboardData || window.clipboardData;
                        const pastedData = clipboardData.getData('text');
                        this.distributeValues(pastedData, idx, inputs);
                    };
                });
            },
            distributeValues(data, startIdx, inputs) {
                if (!data) return;

                const digits = data.replace(/\D/g, '').split('');
                if (!digits) return;

                digits.forEach((digit, i) => {
                    const targetIdx = startIdx + i;
                    if (targetIdx < inputs.length) inputs[targetIdx].value = digit;
                });

                const nextFocusIdx = Math.min(startIdx + digits.length, inputs.length - 1);
                if (inputs[nextFocusIdx]) inputs[nextFocusIdx].focus();

                this.updateOtpValue();
                this.clearOtpErrorState();
            },
            updateOtpValue() {
                const currentModal = this.getCurrentModal();
                const inputs = currentModal?.querySelectorAll('.otp-box input');
                const verifyBtn = currentModal?.querySelector('#btn-verify-otp');

                if ([...inputs].every(input => input.value.trim() !== '')) this.enableButton(verifyBtn);
                else this.disableButton(verifyBtn)
            },
            clearOtpErrorState() {
                const otpBox = this.getCurrentModal()?.querySelector('#otpBox');
                otpBox.classList.remove('error-border', 'shake');
                this.showOrClearOtpVerifyFailed(false);
            },
            startOtpCountdown() {
                const resendBtn = this.getCurrentModal()?.querySelector('#btn-resend-otp');
                this.resetOtpCountdown(Number(this.params.otpCountDown) || 0);
                this.otpTimer = setInterval(() => {
                    this.otpCountDownRealTime--;

                    if (this.otpCountDownRealTime <= 0) {
                        clearInterval(this.otpTimer);
                        this.otpTimer = null;

                        resendBtn.disabled = false;
                        resendBtn.classList.remove('btn-secondary');
                        resendBtn.classList.add('btn-primary')
                    }
                }, 1000);
            },
            resetOtpCountdown(otpCountDown) {
                if (this.otpTimer) clearInterval(this.otpTimer);
                this.otpCountDownRealTime = otpCountDown;
            },
            getCurrentModal() {
                return document.getElementById('div-otp-input')
            },
            enableButton(btn) {
                if (!btn) return;
                btn.disabled = false;
                btn.classList.remove('btn-secondary');
                btn.classList.add('btn-primary')
            },
            disableButton(btn) {
                if (!btn) return;
                btn.disabled = true;
                btn.classList.add('btn-secondary');
                btn.classList.remove('btn-primary')
            },
            focusFirstOtp() {
                this.getCurrentModal()?.querySelector('#input-first-otp-number')?.focus()
            }
        }
    }
</script>

<style scoped>
    .modal-dialog {
        max-width: 600px;
    }

    .modal-close-btn {
        position: absolute;
        top: 1rem;
        right: 1rem;
    }

    .otp-box {
        display: flex;
        justify-content: center;
        flex-wrap: nowrap;
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 10px 0;
        box-sizing: border-box;
    }

    .otp-box input {
        margin: 0 5px;
        flex: 0 1 52px;
        width: 100%;
        height: 60px;
        font-size: 24px;
        text-align: center;
        font-weight: bold;
        color: #111;
        background: #fff;
        border: 2px solid #333;
        border-radius: 4px;
        outline: none;
        box-sizing: border-box;
        transition: all 0.2s ease;
    }

    .otp-box.otp-many input {
        margin: 0 3px;
        flex-basis: 44px;
        height: 52px;
        font-size: 20px;
    }

    .otp-box input:focus {
        border-color: #1e8cbf;
        box-shadow: 0 0 0 2px rgba(30, 140, 191, 0.2);
    }

    .error-msg {
        color: #e53935;
        font-size: 14px;
        text-align: left;
        margin-left: 5px;
        margin-top: 4px;
        word-break: break-word;
    }

    .otp-box.otp-many + .error-msg {
        margin-left: 3px;
    }

    @media (max-width: 576px) {
        .otp-box input {
            margin: 0 3px;
            height: 50px;
            flex-basis: 40px;
            font-size: 18px;
        }

        .error-msg {
            margin-left: 3px;
        }

        .otp-box.otp-many input {
            margin: 0 2px;
            flex-basis: 32px;
            height: 44px;
            font-size: 16px;
        }

        .otp-box.otp-many + .error-msg {
            margin-left: 2px;
        }
    }

    @media (max-width: 350px) {
        .otp-box input,
        .otp-box.otp-many input {
            margin: 0 2px;
            flex-basis: 30px;
            height: 40px;
            font-size: 14px;
            border-width: 1px;
        }

        .error-msg,
        .otp-box.otp-many + .error-msg {
            margin-left: 2px;
        }
    }

    .btn-secondary:disabled {
        cursor: not-allowed !important;
    }

    @keyframes otp-shake {
        0%, 100% {
            transform: translateX(0);
        }
        25% {
            transform: translateX(-4px);
        }
        75% {
            transform: translateX(4px);
        }
    }

    .otp-box.shake input {
        animation: otp-shake 0.15s ease-in-out 0s 2;
        border-color: #e53935;
    }

    .otp-box.error-border input {
        border-color: #e53935;
    }
</style>
